import React, { useState, useEffect } from "react";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import { getApi, postApi } from "../../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  API_LEAVE_GET_OOD_DL_LIST,
  API_GET_ACCESS_TYPES,
  API_ADD_ACCESS_REQUEST,
  API_GET_ALL_ACTIVE_PROJECTS,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { ThreeDots } from "react-loader-spinner";
import * as Yup from "yup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { formatToDateOnly } from "../../utils/helpers";

const AccessRequest = () => {
  const accessToken = Cookies.get("accessToken");
  const [deliveryLead, setDeliveryLead] = useState([]);
  const [endOption, setEndOption] = useState(""); // "ONGOING" or "DATE"
  const [endDate, setEndDate] = useState(null);
  const [accessTypes, setAccessTypes] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [projects, setProjects] = useState([]);
  const [showTypeField, setShowTypeField] = useState(false);
  const [errors, setErrors] = useState({});
  const [accessSubtypes, setAccessSubtypes] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    projectId: null,
    accessType: "",
    deliveryLead: "",
    reason: "",
    type: "",
  });
  const userData = localStorage.getItem("userData");
  const employee = userData ? JSON.parse(userData) : null;
  const employeeId = employee?.id;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData({
      projectId: null,
      accessType: "",
      deliveryLead: "",
      reason: "",
      type: "",
    });
    setEndOption("");
    setEndDate(null);
    setShowTypeField(false);
    setErrors({});
  };

  const validationSchema = Yup.object().shape({
    reason: Yup.string()
      .required("Reason is required.")
      .trim()
      .min(5, "Reason must be at least 5 characters long."),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (
    //   !formData.projectId ||
    //   !formData.accessType ||
    //   !formData.deliveryLead ||
    //   (showTypeField && !formData.type)
    // ) {
    //   return;
    // }

    setIsLoading(true);

    try {
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        projectId: formData.projectId,
        accessId: Number(formData.accessType),
        reason: formData.reason,
        firstApprover: Number(formData.deliveryLead),
        ...(showTypeField && { type: formData.type }),
        endDate:
          endOption === "ONGOING" || !endDate
            ? null
            : formatToDateOnly(endDate),
      };

      const response = await postApi(
        `${API_ADD_ACCESS_REQUEST}/${employeeId}`,
        payload,
        accessToken
      );

      const statusCode = response?.statusCode || response?.data?.statusCode;

      if (statusCode === 200) {
        toast.success(
          response?.message || "Access request submitted successfully!"
        );

        setFormData({
          projectId: null,
          accessType: "",
          deliveryLead: "",
          reason: "",
          type: "",
        });
        navigate("/dashboard/assetRequest?tab=access");

        return;
      }

      toast.error(response?.message || "Failed to submit access request");
    } catch (error) {
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong!");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchDeliveryLeads = async () => {
      try {
        const response = await getApi(API_LEAVE_GET_OOD_DL_LIST, accessToken);

        const leads = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        setDeliveryLead([
          ...leads.map((lead) => ({
            value: lead.id,
            label: lead.fullName || "",
          })),
        ]);
      } catch (error) {
        setDeliveryLead([]);
      }
    };

    fetchDeliveryLeads();
  }, []);

  useEffect(() => {
    const fetchAccessTypes = async () => {
      try {
        const res = await getApi(
          `${API_GET_ACCESS_TYPES}?status=APPROVED`,
          accessToken
        );
        const accessTypesData = res?.data?.data?.accessTypes || [];
        const accessSubtypesData = res?.data?.data?.accessSubtypes || [];

        const types = accessTypesData.map((at) => ({
          value: at.accessId,
          label: at.name,
          isRole: at.isRole,
        }));

        setAccessTypes(types);
        setAccessSubtypes(accessSubtypesData);
      } catch (error) {
        setAccessTypes([]);
        setAccessSubtypes([]);
      }
    };
    fetchAccessTypes();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await getApi(API_GET_ALL_ACTIVE_PROJECTS, accessToken);
        const projectsData = res?.data?.data || res?.data || [];

        if (Array.isArray(projectsData)) {
          const formatted = projectsData.map((p) => ({
            value: p.projectId,
            label: p.projectName,
          }));

          setProjects([{ value: "", label: "All" }, ...formatted]);
        }
      } catch (error) {
        setProjects([{ value: "", label: "All" }]);
      }
    };

    fetchProjects();
  }, []);

  return (
    <>
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <form id="access-request" onSubmit={handleSubmit}>
        <div className="inputs">
          <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label htmlFor="accessType" className="has-asterisk">
                Access Type
              </label>
            </div>
            <div className="col-md-5">
              <Select
                className="custom-select"
                classNamePrefix="react-select"
                id="accessType"
                name="accessType"
                options={accessTypes}
                value={
                  accessTypes.find(
                    (item) => item.value === formData.accessType
                  ) || null
                }
                onChange={(selectedOption) => {
                  setFormData((prev) => ({
                    ...prev,
                    accessType: selectedOption?.value || "",
                  }));

                  const selectedAccess = accessTypes.find(
                    (item) => item.value === selectedOption?.value
                  );
                  const show = selectedAccess?.isRole === 1;
                  setShowTypeField(show);

                  if (!show) {
                    setFormData((prev) => ({ ...prev, type: "" }));
                  }
                }}
                placeholder="Select Access Type"
                isClearable
                required
              />
            </div>
            <div className="col-md-3"></div>
          </div>
          {showTypeField && (
            <div className="row mb-2">
              <div className="col-md-2"></div>
              <div className="col-md-2">
                <label htmlFor="type" className="has-asterisk">
                  Role
                </label>
              </div>
              <div className="col-md-5">
                <Select
                  className="custom-select"
                  classNamePrefix="react-select"
                  id="type"
                  name="type"
                  options={accessSubtypes.map((s) => ({ label: s, value: s }))}
                  value={
                    formData.type
                      ? { label: formData.type, value: formData.type }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setFormData((prev) => ({
                      ...prev,
                      type: selectedOption?.value || "",
                    }))
                  }
                  onInputChange={(inputValue, action) => {
                    if (action.action === "input-change") {
                      const exists = accessSubtypes.includes(inputValue);

                      if (!exists) {
                        setFormData((prev) => ({
                          ...prev,
                          type: "",
                        }));
                      }
                    }
                  }}
                  required
                  placeholder="Select Role"
                  isClearable={true}
                  isSearchable={true}
                />
              </div>
            </div>
          )}
          <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label htmlFor="projectName" className="has-asterisk">
                Project
              </label>
            </div>
            <div className="col-md-5">
              <Select
                className="custom-select"
                classNamePrefix="react-select"
                id="projectId"
                name="projectId"
                options={projects}
                value={
                  projects.find((p) => p.value === formData.projectId) || null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    projectId: selectedOption ? selectedOption.value : null,
                  }))
                }
                placeholder="Select Project"
                isClearable
                required
              />
            </div>
            <div className="col-md-3"></div>
          </div>

          <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label htmlFor="deliveryLead" className="has-asterisk">
                Delivery Lead
              </label>
            </div>
            <div className="col-md-5">
              <Select
                className="custom-select"
                classNamePrefix="react-select"
                id="deliveryLead"
                name="deliveryLead"
                options={deliveryLead}
                value={
                  deliveryLead.find(
                    (dl) => dl.value === formData.deliveryLead
                  ) || null
                }
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    deliveryLead: selectedOption?.value || "",
                  }))
                }
                placeholder="Select Delivery Lead"
                isClearable={true}
                required
              />
            </div>
            <div className="col-md-3"></div>
          </div>

          {/* <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label className="has-asterisk">End Date</label>
            </div>

            <div className="col-md-5">
              <Select
                className="custom-select"
                classNamePrefix="react-select"
                id="endOption"
                name="endOption"
                options={[
                  { value: "ONGOING", label: "Ongoing" },
                  { value: "DATE", label: "Select Date" },
                ]}
                value={
                  endOption
                    ? {
                        value: endOption,
                        label:
                          endOption === "ONGOING" ? "Ongoing" : "Select Date",
                      }
                    : null
                }
                onChange={(selectedOption) => {
                  setEndOption(selectedOption?.value || "");
                  if (selectedOption?.value === "ONGOING") setEndDate(null); // reset date
                }}
                placeholder="Select End Date Option"
                isClearable
                required
              />
            </div>
          </div>

          {endOption === "DATE" && (
            <div className="row mb-2">
              <div className="col-md-2"></div>
              <div className="col-md-2"></div>
              <div className="col-md-5">
                <DatePicker
                  showIcon
                  toggleCalendarOnIconClick
                  placeholderText="mm/dd/yyyy"
                  selected={endDate ? new Date(endDate) : null}
                  onChange={(date) => setEndDate(date)}
                  minDate={new Date()}
                  dropdownMode="select"
                  onKeyDown={(e) => {
                    if (e.key !== "Backspace" && e.key !== "Delete") {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
          )} */}
          <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label className="has-asterisk">End Date</label>
            </div>

            <div className="col-md-5">
              {endOption === "DATE" ? (
                <DatePicker
                  showIcon
                  toggleCalendarOnIconClick
                  placeholderText="mm/dd/yyyy"
                  selected={endDate ? new Date(endDate) : null}
                  onChange={(date) => setEndDate(date)}
                  minDate={new Date()}
                  dropdownMode="select"
                  required
                  onKeyDown={(e) => {
                    if (e.key !== "Backspace" && e.key !== "Delete") {
                      e.preventDefault();
                    }
                  }}
                />
              ) : (
                <Select
                  className="custom-select"
                  classNamePrefix="react-select"
                  id="endOption"
                  name="endOption"
                  options={[
                    { value: "ONGOING", label: "Ongoing" },
                    { value: "DATE", label: "Select Date" },
                  ]}
                  value={
                    endOption
                      ? {
                          value: endOption,
                          label:
                            endOption === "ONGOING" ? "Ongoing" : "Select Date",
                        }
                      : null
                  }
                  onChange={(selectedOption) => {
                    setEndOption(selectedOption?.value || "");
                    if (selectedOption?.value === "ONGOING") setEndDate(null);
                  }}
                  placeholder="Select "
                  isClearable
                  required
                />
              )}
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-2"></div>
            <div className="col-md-2">
              <label htmlFor="reason" className="has-asterisk">
                Reason
              </label>
            </div>
            <div className="col-md-5">
              <div className="input-group">
                <textarea
                  rows={4}
                  cols={5}
                  id="reason"
                  name="reason"
                  value={formData.reason}
                  required
                  onChange={handleInputChange}
                ></textarea>
                {errors.reason && (
                  <small className="text-danger">{errors.reason}</small>
                )}
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>

          <br />

          <div className="action d-flex justify-content-center align-items-center">
            <button
              className="btn btn-secondary px-3 py-2"
              onClick={handleReset}
              type="button"
            >
              Reset
            </button>
            <button
              className="theme-button ms-2"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <ThreeDots
                  height="22"
                  width="50"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                " Submit "
              )}
            </button>
          </div>
        </div>
      </form>

      <Footer />
    </>
  );
};

export default AccessRequest;
